import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { RouterModule } from '@angular/router';
import { EpdkErrorPageModule } from '../error-page/error.page.module';
import { EpdkXLogoModule } from '../x-logo/x-logo.module';
import { EpdkAppRootComponent } from './app-root.component';

@NgModule({
  imports: [
    // Angular.
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatSidenavModule,
    RouterModule,

    EpdkErrorPageModule,
    EpdkXLogoModule
  ],
  declarations: [EpdkAppRootComponent],
  exports: [EpdkAppRootComponent]
})
export class EpdkAppRootModule { }